const options = {
  Q1: [
    "National Credit Bureau",
    "No-Claim Bonus",
    "Non-Commissioned Banks",
    "National Co-Operative Bank",
  ],
  Q2: [
    "Only Option-(a) is Correct.",
    "Only Option-(b) is Correct.",
    "Only Option-(c) is Correct.",
    "Only Option-(d) is Correct.",
  ],
  Q3: [
    "5 Years and 80 Years",
    "16 Years and 100 Years",
    "21 Yearsand 90 Years",
    "18 Yearsand 80 Years",
  ],
  Q4: ["6 Months", "One Year", "Five Years", "Life-Time"],
  Q5: [
    "Damage by Cyclone",
    "Damage by Fire",
    "Damage in Road-Accident",
    "Damage in Transit",
  ],
  Q6: [
    "Risk and Address",
    "Address and Name",
    "Risk and Policy",
    "Premium and Risk",
  ],
  Q7: ["Agent", "Insured", "Insurer", "Profit"],
  Q8: ["Insurer", "Insured", "Insurance Agent", "Insurance Broker"],
  Q9: [
    "The Policy Document has to be signed by a Competent Authority, but need     not be compulsorily stamped according to Indian Stamp Act.",
    "The Policy Document has to be signed by a Competent Authority, and should be stamped according to Indian Stamp Act.",
    "The Policy Document need not be signed by a Competent Authority, but should be stamped according to Indian Stamp Act.",
    "The Policy Document neither needs to be signed by a Competent Authority, nor it needs to be compulsorily stamped according to Indian Stamp Act.",
  ],
  Q10: [
    "Insured is a Minor",
    "Nominee is a Minor",
    " Policy-Holder is Not of Sound Mind",
    "Policy-Holder is Not Married",
  ],
  Q11: [
    "If the Premiums are Not Paid on the Due-Date.",
    "If the Premiums are Not paid, Before the Due-Date.",
    "If the Premium has Not been paid, even After Expiry of Grace-Period.",
    "If the Policy is surrendered.",
  ],
  Q12: [
    "To Transfer the Rights of the Policy.",
    "To Appoint a Person, to Receive the Policy-Monies, in the Event of the Life-Assured's Death.",
    "To Surrender the Policy.",
    "To Create an Estate.",
  ],
  Q13: [
    "Reserve Bank of India (R.B.I.) and Finance Ministry, Together.",
    "Securities and Exchange Board of India (S.E.B.I.) and Association of Mutual Funds in India (A.M.F.I.), Together.",
    "Insurance Regulatory and Development Authority of India (I.R.D.A.I.)",
    "Finance Ministry",
  ],
  Q14: [
    "Regulator",
    "Third-Party Administrator",
    "Insurance Agents or Brokers",
    "All of the Above.",
  ],
  Q15: [
    "Only, I and II.",
    "Only, I and IV.",
    "I, II, and IV.",
    " I, II, III, and IV.",
  ],
  Q16: ["Mortality", "Morbidity", "Risk-Selection", "Probability"],
  Q17: ["Only I.", "I and II.", "I and III.", "I, II, and III."],
  Q18: [
    "Registration",
    "Coding of the Claim",
    "Intimation",
    "Verification of Documents",
  ],
  Q19: [
    "Reimbursement Claim",
    "Cash-Less Facility",
    "Pay-As-You-Go Claim",
    "“Treat First, Pay Later",
    "Claim",
  ],
  Q20: [
    "National Bureau of Finance Companies",
    "Non-Banking Financial Company",
    "Non-Bank Finance Company",
    "Non-Banking Financial Corporation",
  ],
  Q21: [
    "Causes of Fire",
    "Problems encountered by Cargo or Goods, in Transit or Storage",
    "Process involved in an Industry",
    "Likely Causes of Fire",
  ],
  Q22: [
    "Both: (a) and (b), are Correct.",
    "Both: (a) and (d), are Correct.",
    "Both: (b) and (c), are Correct.",
    "Both: (c) and (d), are Correct.",
  ],
  Q23: [
    "To ensure that, Rural Areas and Weaker Sections of Population gets the Adequate Insurance-Coverage.",
    "To ensure that, Insurance Companies generate the Sufficient Profits, so that, they can Survive in the Long-Term.",
    "To ensure that, Insurance-Cover is extended to All the Citizens of India.",
    "To Protect the Policy-Holders' Interests.",
  ],
  Q24: [
    "To Transfer the Rights of the Policy.",
    "To Appoint a Person, to Receive the Policy-Monies, in the Event of the Life-Assured's Death.",
    "To Surrender the Policy",
    "To Create an Estate",
  ],
  Q25: ["1999", "2000", "2002", "2003"],
};

export default options;
